export default __webpack_public_path__ + "static/media/cloud3.e622395b.svg";